<!--村级待提交 -->
<template>
  <div style="width: 100%">
    <div class="searchcontent" style="padding:0px" >
    </div>
    
    <div class="searchtable">
      <el-table
        ref="table"
        :data="systemlist"
        border
        stripe
        v-loading="showDataLoading"
        :header-row-style="{height:'30px'}"
        :header-cell-style="{padding:'5px'}"
        :row-style="{height:'30px'}"
        :cell-style="{padding:'5px'}"
        :height="tableHeight"
      >
      
        <el-table-column prop="settingID" label="编号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column prop="policyMeasureName" label="政策措施" min-width="200">
        </el-table-column>
        
        <el-table-column prop="currentProgressName" label="当前进度" width="180">
        </el-table-column>
        <el-table-column
                    prop="waitSubmitNum"
                    label="数量(个)"
                    width="150">
        </el-table-column>
        <el-table-column label="操作"  width="200">
           <template slot-scope="scope">  <!--:disabled='region_level != 5' -->
            <el-button type="text" size="mini"   v-if="permission.isHaveLookPermission"  @click="lookDetail(scope.row)" title="查看详情">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pageblock">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <!--详情-->
    <el-dialog  
            :title="particularstitle"
            :show-close="true"
            :close-on-click-modal="false"
            custom-class="dialog_wrap"
            :visible.sync="dialogdetailVisible"
            class="eldialog detaildialog"
            v-loading="showDataDetailLoading"
            :modal-append-to-body="true"
             append-to-body
            :style="'margin-top:0px;left:' + initLeft()"
            >
            <div class="searchcontent">
                <el-form :inline="true"  class="demo-form-inline">
                            <el-form-item>
                                <el-input size="small" v-model.trim="detailsearchForm.keywords" placeholder="请输入申请人姓名" ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input size="small" v-model.trim="certificateNo" placeholder="请输入申请人证件号"   maxlength="18"  onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
                            </el-form-item>      
                            <el-form-item>
                                <el-button size="small" plain type="primary" icon="el-icon-search"  @click="ondetailsearchForm">查询</el-button>
                            </el-form-item>
                            <!-- <el-form-item  v-if="detailshowstatus"> 
                                <el-button size="small" plain type="primary" icon="el-icon-upload2" @click="onDownload">导出</el-button>
                            </el-form-item> -->
                            <el-form-item v-if="detailshowstatus"> <!--@click="onbatchchecked" -->
                                <!-- <el-button size="small" plain type="primary" icon="el-icon-s-check" v-if="permission.isHaveSubmitPermission"  @click="onSubmitcheck">提交审核</el-button> -->
                                <el-button size="small" plain type="primary" icon="el-icon-s-check" v-if="permission.isHaveSubmitPermission"  @click="onSubmitcheck" :disabled='region_level != 5'>提交审核</el-button>
                               
                            </el-form-item>
                             <el-form-item v-if="detailshowstatus==false && permission.isHavetownshippublicitylistwordPermission"> <!--@click="onbatchchecked" -->
                                <el-button size="small" plain type="primary" icon="el-icon-upload2"  @click="exportfile">导出公示名单</el-button>
                            </el-form-item>
                             <el-form-item v-if="detailshowstatus==false">
                                <div class="uploadFile" style="width:50%;">
                                    <el-upload
                                        :disabled="authenStatus==0?true:false" 
                                        ref="my-upload"
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :headers="uploadheaders"
                                        multiple
                                        :limit="9"
                                        accept=".jpg, .jpeg, .png"
                                        :on-exceed="handleExceed"
                                        :on-success="haneditVideoSuccess"
                                        :before-upload="beforeUpload"
                                        :data="{sourceType: sourceType ,timestamp:tiem,_sign:sign}"
                                        :file-list="fileList"
                                        :show-file-list="false"
                                         :on-change="handFileChange"
                                    >
                                        <el-button size="small" plain icon="el-icon-picture-outline"   v-if="permission.isHavePublicPermission" type="primary" @click="submitUpload">上传公示照片</el-button>
                                    </el-upload>
                                    </div>
                            </el-form-item>
                            <!-- <el-form-item> 
                                <el-button size="small" plain type="primary" icon="el-icon-picture-outline" v-if="detailshowstatus==false" @click="oncheckList">上传公示照片</el-button>
                            </el-form-item> -->
                            <el-form-item v-if="detailshowstatus==false"> <!--@click="onbatchchecked" -->
                                <el-button size="small" plain type="primary" icon="el-icon-check"  v-if="permission.isHavePublicPermission"  @click="completecheck">完成公示</el-button>
                            </el-form-item>
                </el-form>
           </div>
        <div class="searchtable" >
            <el-table
                ref="table"
                :data="applyaudituserlist"
                 border
                stripe
                v-loading="showDataLoading"
                :header-row-style="{height:'30px'}"
                :header-cell-style="{padding:'5px'}"
                :row-style="{height:'30px'}"
                :cell-style="{padding:'5px'}"
                @selection-change="handleSelectionChange"
                >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column prop="" label="编号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
                </el-table-column>
                 <el-table-column
                    prop="applyType"
                    label="申请来源"
                    width="90"
                    >
                     <template slot-scope="scope">
                    <span v-if="scope.row.applyType == 1">个人申请</span>
                    <span v-if="scope.row.applyType == 2">窗口受理</span> 
                </template> 
                </el-table-column>
                <el-table-column
                    prop="realName"
                    label="申请人姓名"
                    width="100"
                    >
                </el-table-column>
             
                 <el-table-column
                    prop=""
                    label="性别"
                   width="60" 
                   >
                    <template slot-scope="scope">
                    <span v-if="scope.row.sexID == 1">男</span>
                    <span v-if="scope.row.sexID == 2">女</span> 
                </template>   
                </el-table-column>
                 <el-table-column
                    prop="userBirthday"
                    label="出生年月"
                    width="100"
                   >
                </el-table-column>
                 <el-table-column
                    prop="certificateNo"
                    label="身份证号"
                    width="165"
                   >
                </el-table-column>
                 <el-table-column
                    prop="maritalStatus"
                    label="婚姻状况"
                    width="85"
                   >
                   <!-- 1初婚；2再婚；3离婚；4丧偶 -->
                    <template slot-scope="scope">
                    <span v-if="scope.row.maritalStatus == 1">初婚</span>
                    <span v-if="scope.row.maritalStatus == 2">再婚</span> 
                    <span v-if="scope.row.maritalStatus == 3">离婚</span>
                    <span v-if="scope.row.maritalStatus == 4">丧偶</span>
                </template>  
                </el-table-column>
                  <el-table-column
                    prop="enjoyCensusAddress"
                    label="户籍地"
                    min-width="180"
                   >
                </el-table-column>
                  <el-table-column
                    prop="surviveChildrenNum"
                    label="现子女数"
                    width="85"
                   >
                </el-table-column>
                  <el-table-column
                    prop="contactTel"
                    label="联系电话"
                     width="120"
                   >
                </el-table-column>
                  <el-table-column
                    prop="applyTime"
                    label="申请时间"
                    width="100"
                   >
                </el-table-column>
                  <el-table-column
                    prop="publicityStatus"
                    label="公示状态"
                    width="100"
                   >
                     <template slot-scope="scope">
                    <span v-if="scope.row.publicityStatus == 7">待公示</span>
                    <span v-if="scope.row.publicityStatus == 8">公示中</span> 
                    <span v-if="scope.row.publicityStatus == 9">已完成</span> 
                </template>   
                </el-table-column>
                 <el-table-column
                    prop="galleryCount"
                    label="公示图集"
                    width="100"
                   >
                    <template slot-scope="scope">
                      <span @click="getGalleryl(scope.row)"  v-if="permission.isHavelooktownsPermission">
                        <el-link type="primary" v-if="permission.isHavelooktownsPermission">图集({{scope.row.galleryCount}})</el-link>
                      </span>
                      <span v-else>
                        <el-link  v-if="permission.isHavelooktownsPermission">图集({{scope.row.galleryCount}})</el-link>
                      </span>
                    </template>
                </el-table-column>
                
                <el-table-column
                    label="操作"
                    fixed="right"
                   width="160" >
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini" @click="editFunds(scope.row)"  >查看资料</el-button>
                        <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini"  v-if="permission.isHaveRepeatPermission"   class="tablecolumn" @click="retrialChecked(scope.row,scope.$index)" :disabled='region_level != 5'>重审</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pageblock">
            <el-pagination
            @size-change="handledatailSizeChange"
            @current-change="handledatailCurrentChange"
            :current-page="page"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="datailtotalCount"
            >
            </el-pagination>
             </div>
        </div>
    </el-dialog>
    <!-- 查看资料 -->  
    <el-dialog title="查看资料" :show-close="true"
      :close-on-click-modal="false"
      custom-class="dialog_wrap"
      :visible.sync="dialogdataFormVisible"
      class="eldialog"
      :modal-append-to-body="true"
        append-to-body
      :style="'margin-top:0px;left:' + initLeft()"
      @close="clearlookoverList()"
      >
        <!-- <Particulars :valueID="applyRecordID" :indexID="keyindex" :markID="mark" ></Particulars> -->
        <Particulars :valueID="applyRecordID"  :indexID="keyindex" :markID="mark" :markshow="markshowID"  :markauditStatus="markauditStatusID" :markuser="markuserID" :markpolicyMeasure="markpolicyMeasureID" :markrewardRecord="markrewardRecordID" :filterShowdata="dialogdataFormVisible" @getStatedata="getTypedata"></Particulars>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogdataFormVisible = false">取 消</el-button>
        </div>
    </el-dialog>
       <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="dialogFormVisible" :show-close="true"  custom-class="dialog_wrap"    @close="clearEditList('checkedForm')"   style="margin-top:0px;left: 0px;z-index: 2154;"  class="logindialog" width="600px">
      <el-form ref="checkedForm" :rules="rules" label-width="130px" :model="checkedForm">
            <el-form-item label="是否通过" >
          <el-radio v-model="checkedForm.is_audit_pass" label="0">否</el-radio>
          <el-radio v-model="checkedForm.is_audit_pass" label="1">是</el-radio>
          </el-form-item>
            <el-form-item label="不通过原因：" prop="people_logout_reason_id"  v-if="checkedForm.is_audit_pass==`0`">
                  <el-select size="medium" v-model="checkedForm.noPassReason" placeholder="请选择不通过原因" >
                      <el-option
                      v-for="item in checkedForm.noPassReasonList"
                      :key="item.systemCodeID"
                      :label="item.systemCodeName"
                      :value="item.systemCodeID">
                      </el-option>
                  </el-select>
          </el-form-item>   
          <el-form-item label="不通过原因：" prop="noPassReasontext"  class="textarea"  v-if="checkedForm.is_audit_pass==`0`">
                  <el-input
                      type="textarea"
                      maxlength="1000"
                      :rows="4"
                      placeholder="请输入不通过原因(最多可录入1000字)"
                      v-model.trim="checkedForm.noPassReasontext">
                      </el-input>
              </el-form-item>   
      </el-form>
      
      <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="oncheckSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 公示列表图集 -->
    <el-dialog
       title="公示图集"
      :show-close="true"
      :close-on-click-modal="false"
      custom-class="dialog_wrap"
      width="100%"
      style="margin-top:0px; margin: 0 aotu"
      :visible.sync="dialogImglistVisible"
      class="eldialog"
      :style="'margin-top:0px;left:' + initLeft()"
     >
      <div class="searchtable">
        <el-table
          ref="table"
          :data="gallerylist"
          border
          stripe
          :v-loading="showDataLoadingimg"
          :header-row-style="{height:'30px'}"
          :header-cell-style="{padding:'5px'}"
          :row-style="{height:'30px'}"
          :cell-style="{padding:'5px'}"
        >
          <el-table-column prop="infoID" label="编号" width="100">
            <template slot-scope="scope">{{scope.$index+1}}</template>
          </el-table-column>
          <el-table-column label="公示图片" min-width="350">
            <template slot-scope="scope">
              <el-popover placement="right" title trigger="hover">
                <img :src="scope.row.galleryUrl" style="max-height: 800px;max-width: 800px" />
                <img
                  slot="reference"
                  :src="scope.row.galleryUrl"
                  style="max-height: 50px;max-width: 50px"
                />
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <div class="pageblock">
          <el-pagination
            @size-change="imghandleSizeChange"
            @current-change="imghandleCurrentChange"
            :current-page="imgpage"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="imgpageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="imgtotalCount"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import { systemcodeModule } from "@/request/systemmange.js";
import { applyaudit2Model,applypublicitygalleryinfolistModel ,applyaudit10Model} from "@/request/applyauditmanage.js";
import { regionModule } from "@/request/systemmange.js";
import baseUrl from "@/request/base.js";
import { sysframe } from '@/tools/sysframe.js'
import { permissionTool } from "@/tools/permissiontool.js";
import $ from 'jquery'
import store from '@/store'
import {baseconfig,rsaBasicModuleConfig} from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import {publicFun} from '@/tools/time.js'
import Particulars from "@/components/windowtoaccept/particulars.vue";
import { downloadFile } from "@/request/utils/downloadexcel.js";
export default {
   components: {
        Particulars,
    },
    props: ["valueID","indexID","markID","markrewardRecord","markpolicyMeasure","markuser","markshow","markauditStatus","filterShowdata"],
  data() {
    var validateCallTitle = (rule, value, callback) => {
      if (this.operErrors.title) {
        callback(new Error(this.operErrors.title));
      } else {
        callback();
      }
      if (this.operErrors.orderWeight) {
        callback(new Error(this.operErrors.orderWeight));
      } else {
        callback();
      }
    };
    return {
      // 重申审核状态
      markshowID:0,
      markauditStatusID:0,
      markpolicyMeasureID:0,
      markuserID:0,
      markrewardRecordID:0,
      mark:1,
      keyindex:0,
      tableHeight:400,
      size: '',
      disabled:false,
      loading:false,
      systemlist: [],
      lsp: [],
      permission: {
        isHaveLookPermission: false,
        isHavePublicPermission: false,
        isHaveSubmitPermission: false,
        isHaveRepeatPermission: false,
        isHavetownshippublicitylistwordPermission:false,
        isHavelooktownsPermission:false,
      },
      dateContent:[],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      dialogImglistVisible:false,
      gallerylist:[],
      imgpage: 1,
      imgpageSize: 10,
      imgtotalCount: 0,
      showDataLoadingimg:false,
      //搜索
      searchForm: {
       keywords:'',
      },
      page: 1,
      pagesize: 10,
      datailtotalCount: 0,
      detailsearchForm: {
       keywords:'',
       villageID:"",
       certificateNo:'',
      },
      //进来加载数据是否展示loading圈
      showDataLoading: true,
      showDataDetailLoading:true,
      authenStatus:1,
      //添加-修改
      operKey: 0,
      fileList:[],
      uploadList: [],
      dialogVisible:false,
      dialogFormVisible:false,
      dialogOperFormVisible: false,
      dialogdetailVisible:false,
      dialogdataFormVisible:false,
      applyaudituserlist:[],
      operbuttonloading: false,
      operbuttondisabled: false,
      villageList:[],
      p_region_id:'',
      region_level:'',
      detailshowstatus:false,  
      //详情
      detailKey: 1,
      dialogDetailFormVisible: false,
      detaiForm: {
        detail: "",
      },
      checkedForm:{
          is_audit_pass: "0",
          noPassReason:'',
          noPassReasonList:[],
          noPassReasontext:'',
          apply_record_id:'',
          user_id:'',
          policy_measure_id:'',
      },
      rules:{

      },
      multipleSelection: [],
      childListlist:[], 
      editstep:1,
      uploadUrl: "",
      uploadheaders: {},
      isMultiple: true,
      list: [],
      sourceType:1,
      tiem:'',
      sign:'',
      uploadNum:0,
    // 申请记录id
      applyRecordID:0,
      gallery_type:3, 
      imgapplyRecordID:0,
       policyMeasureName:'' , 
       particularstitle:'',
       certificateNo:''
     };
  },
  created: async function () {
        await this.getapplyaudit2list(
        this.pageIndex,
        this.pageSize,
        ''
        );
        this.p_region_id =  store.getters.adminRegionID
        this.region_level =store.getters.adminRegionLevel
      
        //上传公示照片
        let plat_form=3
        this.sign=rsa.signString(baseconfig.v + String(plat_form) + '~AUF',rsaBasicModuleConfig.clientPrivateKey)
        //时间戳
        this.tiem=rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey);
        this.uploadUrl = baseUrl.basic + "uploadfile";
        this.uploadheaders = {
          v:baseconfig.v,
          platform:3,
        };
       
            
     this.getSystemcodeinfogetlist(13)
    //$('.el-table ').css('min-height',($(".tab-content").height()-40-$(".pageblock").outerHeight(true))+'px')
    this.tableHeight=$(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true)
    this.permission.isHaveLookPermission = permissionTool.isHavePermission(
      "lookapplyauditvillage2userlist",
      this.lsp
    );
    this.permission.isHavePublicPermission = permissionTool.isHavePermission(
      "applybatchsubmitforapprocal12",
      this.lsp
    );
    this.permission.isHaveSubmitPermission = permissionTool.isHavePermission(
      "applyrepeataudit12",
      this.lsp
    );
    this.permission.isHaveRepeatPermission = permissionTool.isHavePermission(
      "villageshippublicitylistword",
      this.lsp
    );
      // 导出公式列表
    this.permission.isHavetownshippublicitylistwordPermission = permissionTool.isHavePermission(
      "applybatcheditpublicitystatus3",
      this.lsp
    );
    // 查看公示图集列表
    this.permission.isHavelooktownsPermission = permissionTool.isHavePermission(
      "lookvillageshipapplypublicitygalleryinfolist",
      this.lsp
    );
  },
  mounted: function () {},
  methods: {
    initLeft(){
        return sysframe.getSideBarLeft()
    },
      
    submitUpload() {
        if(this.multipleSelection==''){
           this.$message.error('请选择申请人');
           this.authenStatus =0
            return  
            
        }else{
          let state = 1
           this.multipleSelection.forEach(e=>{
            //  publicityStatus:公示状态，UI展示（待公示、公式中、已完成）
            if(e.publicityStatus != 7 )
                state = 2
            })
            if(state == 2){
                 this.$message.error('请选择未公示的申请人');
                      this.authenStatus = 0
                  return 
            }else{
              this.authenStatus = 1
            }
        
        }
      },
     //获取搜索框的 下拉框
    async getSystemcodeinfogetlist(mark) {
          await systemcodeModule.systemcodeinfogetlist(mark).then((response) => {
              switch (response.data.code) {
                  case 100:{
                      this.checkedForm.noPassReasonList = response.data.result
                  }
                    break;
                }
              })
              .catch((error) => {
              console.log("error", error);
          });
      },
    async getapplyaudit2list( page, pagesize,keywords) {
      this.systemlist = [];
      await applyaudit10Model
        .applyauditvillage2list( page, pagesize,keywords)
        .then((response) => {
          this.showDataLoading = false;
          if(response.data.lsp !==null){
              this.lsp=response.data.lsp
          }
          switch (response.data.code) {
            case 100:
              this.systemlist = response.data.result;
             
              this.totalCount =   response.data.recordcount;
              break;
            case 101:
            this.systemlist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },
    getRowKey(row) {
      return row.noticeID;
    },
    //更改每页显示条数
    async handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      await this.getapplyaudit2list(
        this.pageIndex,
        this.pageSize,
        this.searchForm.keywords
      );
    },
    //设置当前页
    async handleCurrentChange(val) {
      this.pageIndex = val;
      await this.getapplyaudit2list(
      this.pageIndex,
      this.pageSize,
      this.searchForm.keywords
    );
    },
    async onSearch() {
      this.totalCount = 0;
      this.pageIndex = 1;
      await this.getapplyaudit2list(
      this.pageIndex,
      this.pageSize,
      this.searchForm.keywords
    );
    },

    lookDetail(row){
          this.dialogdetailVisible = true
          this.checkedForm.policy_measure_id = row.policyMeasureID
          this.detailsearchForm.keywords = ''
          this.detailsearchForm.villageID = ''
          this.policyMeasureName=row.policyMeasureName
           this.particularstitle=this.policyMeasureName+'-'+'申请人列表'
           this.uploadList = [],
          this.getapplyaudit1userlist(1,10,row.policyMeasureID,'',0,0,'') 
    },
        //详情列表
    async getapplyaudit1userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
      if(region_id ==''){
        region_id = 0
          region_level=0
      }
      this.applyaudituserlist = [];
      this.showDataLoading = true;
      await applyaudit10Model
        .applyauditvillage2userlist( page,page_size,policy_measure_id,key_words,region_level,region_id,id_number)
        .then((response) => {
          this.showDataLoading = false;
          if(response.data.lsp !==null){
              this.lsp=response.data.lsp
          }
          switch (response.data.code) {
            case 100:
              this.applyaudituserlist = response.data.result;
              this.detailshowstatus = true
              this.applyaudituserlist.forEach(e=>{
                    e.applyTime = publicFun.timestampToTime(e.applyTime).substring(0,10)
                    e.userBirthday = publicFun.timestampToTime(e.userBirthday).substring(0,10)
                    e.marriageChanges =  publicFun.timestampToTime(e.marriageChanges).substring(0,10)
                    if(e.publicityStatus!=9){
                         this.detailshowstatus = false   
                    }
            })
              this.datailtotalCount =  response.data.recordcount;
             
              break;
            case 101:
            this.applyaudituserlist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },

  //更改每页显示条数
    async handledatailSizeChange(val) {
      this.pagesize = val;
      this.page = 1;
      this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,0,0,this.certificateNo) 
      
    },
    //设置当前页
    async handledatailCurrentChange(val) {
      this.page = val;
      this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,0,0,this.certificateNo) 

    },
    async ondetailsearchForm() {
      this.datailtotalCount = 0;
      this.page = 1;
      // this.certificateNo
      this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,0,0,this.certificateNo) 

    },
    clearchecked(){
         this.dialogFormVisible = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    oncheckList(){
        this.dialogFormVisible = true
    },
    checked(row){
      
      

    },
    onSubmitcheck(){
        if(this.multipleSelection==''){
          this.$message.error('请选择申请人');
          return false
      }
        let apply_record_ids = []
          let user_ids = []
          this.multipleSelection.forEach(e=>{
              apply_record_ids.push(e.applyRecordID)   
              user_ids.push(e.userID) 
          })
      
        this.applybatchsubmitforapprocal( `[` + apply_record_ids.toString()+ `]`,`[` + user_ids.toString()+ `]`,this.checkedForm.policy_measure_id ,5 )
    },
    //申报审核-批量提交审核--CGX
    async applybatchsubmitforapprocal(apply_record_ids,user_ids,policy_measure_id,mark) {
      await applyaudit2Model
        .applybatchsubmitforapprocal(apply_record_ids,user_ids,policy_measure_id,mark)
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,0,0,this.certificateNo) 
                this.getapplyaudit2list(
                this.pageIndex,
                this.pageSize,
                ''
                );
                const h = this.$createElement;
                this.$notify({
                    title: "成功",
                    message: h("span", response.data.message),
                    type: "success",
                });
              }
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },
    //关闭添加修改弹框时重置
    clearEditList(checkedForm){
        this.$refs[checkedForm].resetFields();
        console.log("sdhkas")
      
        this.clear()
        this.$forceUpdate()
    },
    clear(){
          this.checkedForm.noPassReasontext = '' 
            this.checkedForm.noPassReason = '' 
          this.checkedForm.is_audit_pass = '0'  
    },
    //上传公示照片
    beforeUpload(file){ // 上传前 文件校验
       
        this.tiem = rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey);
        if(this.multipleSelection==''){
           this.$message.error('请选择申请人');
            return false
        }else{
          let state = 1
           this.multipleSelection.forEach(e=>{
            if(e.publicityStatus != 7)
                state = 2
            })
            if(state == 2){
                 this.$message.error('请选择未公示的申请人');
                  return false
            }
          return true// 返回false不会自动上传
        }
        
    },
    
    handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handFileChange(files, fileList) {
     console.log('cccccccccccccccc')
      var upload_img = document.getElementsByClassName('upload-demo')
      if (upload_img && upload_img.length > 0) {
        var upload = upload_img[0].getElementsByTagName('input')
        if (upload && upload.length > 0 && upload[0].files && upload[0].files.length > 0) {
          this.uploadNum = upload[0].files.length
          console.log(this.uploadNum)
        }
      }
    },
    haneditVideoSuccess(res) {
     console.log('00000000')
      //获取上传图片地址
      //  console.log(res.result);
   // 
      if (res.code == 100) {
         for (let i = 0; i <res.result.length; i++) {
            var imgObj = {
              source_img_url: res.result[i].imgUrl,
            };
              this.uploadList.push(imgObj);
          }
       //     this.$refs['my-upload'].clearFiles();
       console.log(this.uploadNum,this.uploadList.length)
        if(this.uploadList.length==this.uploadNum){
          let apply_record_ids = []
            let user_ids = []
            this.multipleSelection.forEach(e=>{
                apply_record_ids.push(e.applyRecordID)   
                user_ids.push(e.userID) 
            })
            // let imgstr=''
            // this.uploadList.forEach(e=>{
            //     var str =   JSON.stringify( e)
            //    imgstr=imgstr+str.substr(1, str.length-2)+',' 
              
            // })
        console.log( JSON.stringify(this.uploadList))   
           
        this.applybatcheditpublicitystatus(`[` + apply_record_ids.toString()+ `]`,`[` + user_ids.toString()+ `]`,this.checkedForm.policy_measure_id,JSON.stringify(this.uploadList),8)
          this.uploadList = []
        }
      } else {
          this.$message.error(res.message);
          this.$refs['my-upload'].clearFiles();
      }
    },

    //申报审核-批量修改公示状态
    async applybatcheditpublicitystatus(apply_record_ids,user_ids,policy_measure_id,gallery_json,publicity_status) {
   //   console.log(gallery_json)
      await applyaudit2Model
        .applybatcheditpublicitystatus(apply_record_ids,user_ids,policy_measure_id,gallery_json,publicity_status)
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                  this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,0,0,this.certificateNo) 
                    const h = this.$createElement;
                    this.$notify({
                        title: "成功",
                        message: h("span", response.data.message),
                        type: "success",
                    });
                }
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },
    //完成公示
    completecheck(){
       if(this.multipleSelection==''){
           this.$message.error('请选择申请人');
            return 
        }else{
          let state = 1
           this.multipleSelection.forEach(e=>{
             console.log(555,e.publicityStatus)
             if(e.publicityStatus != 8)
                state = 2
            })
            if(state == 2){
                 this.$message.error('请选择公示中的申请人');
                  return 
            }
          
        }
       let apply_record_ids = []
            let user_ids = []
            this.multipleSelection.forEach(e=>{
                apply_record_ids.push(e.applyRecordID)   
                user_ids.push(e.userID) 
            })
        this.applybatcheditpublicitystatus(`[` + apply_record_ids.toString()+ `]`,`[` + user_ids.toString()+ `]`,this.checkedForm.policy_measure_id, '',9)

    },
    //重审
    retrialChecked(row){
        this.checkedForm.apply_record_id = row.applyRecordID
        this.checkedForm.user_id =row.userID
        this.dialogFormVisible = true
    },
    oncheckSubmit(){
        if(this.checkedForm.is_audit_pass == '0'){
            if(this.checkedForm.noPassReasontext==''&& this.checkedForm.noPassReason==''){
                this.$message.error('请输入或选择不通过原因');
                    return
            }
        }
           var noPassReason = ''
        if(this.checkedForm.noPassReason==''){
               noPassReason=0
        }else{
             noPassReason=this.checkedForm.noPassReason
        }
      
          console.log(this.checkedForm.is_audit_pass)
          this.applyrepeataudit( this.checkedForm.apply_record_id,this.checkedForm.user_id,this.checkedForm.policy_measure_id ,this.checkedForm.is_audit_pass,noPassReason,this.checkedForm.noPassReasontext,)
    },
    async applyrepeataudit(apply_record_id,user_id,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason) {
      await applyaudit2Model
        .applyrepeataudit(apply_record_id,user_id,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason)
        .then((response) => {
          switch (response.data.code) {
            case 100:{
               this.dialogFormVisible = false
            
              this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,0,0,this.certificateNo) 
                this.getapplyaudit2list(
                this.pageIndex,
                this.pageSize,
                ''
                );
              const h = this.$createElement;
                this.$notify({
                    title: "成功",
                    message: h("span", response.data.message),
                    type: "success",
                });
              }
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },
    // 查看资料
    editFunds(row){
      this.keyindex++
      this.dialogdataFormVisible=true
      this.applyRecordID=row.applyRecordID
        //审核  
      this.markrewardRecordID=row.applyRecordID
      this.markpolicyMeasureID=this.checkedForm.policy_measure_id
      this.markuserID=row.userID
      this.markauditStatusID=0
     //展示审核
      this.markshowID=7
    },
    clearlookoverList(){
      // this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,this.region_level,this.detailsearchForm.villageID) 
    },
    getTypedata(val){
      console.log('关闭页面事件')
      this.dialogdataFormVisible=val
      this.getapplyaudit2list(
        this.pageIndex,
        this.pageSize,
        this.searchForm.keywords
      );
     this.getapplyaudit1userlist( this.page,this.pagesize,this.checkedForm.policy_measure_id,this.detailsearchForm.keywords,0,0,this.certificateNo) 
    },
      
    onDownload(){

    },
    exportfile(){
      let region_level
      let villageID
      if(this.detailsearchForm.villageID ==''){
          villageID = 0
          region_level=0
      }
      
        const adminToken = store.getters.adminID
          var paras = {   
              mark:3,
              key_words:this.detailsearchForm.keywords,
              policy_measure_id: this.checkedForm.policy_measure_id,
              region_level:region_level,
              region_id:villageID,
              id_number:this.certificateNo,
        timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
        _sign: rsa.signString(baseconfig.v + adminToken +'~cv1qQOWHRIPi',rsaBasicModuleConfig.clientPrivateKey)
        }
          downloadFile('publicitylistword',"docx",paras,"公示列表").then(res=>{
            // this.addbuttonloading = false
            // this.addbuttondisabled = false
            console.log(2222,res)
        });
    
    },
    //图集
    async getGalleryl(row) {
      this.dialogImglistVisible = true;
      this.imgapplyRecordID=row.applyRecordID
      this.imgpage
      await this.getapplypublicitygalleryinfolist(this.imgpage, this.imgpageSize, row.applyRecordID,this.gallery_type);
    },
    //更改每页显示条数
    async imghandleSizeChange(val) {
      this.imgpageSize = val;
      this.imgpage = 1;
      await this.getapplypublicitygalleryinfolist(this.imgpage, this.imgpageSize, this.imgapplyRecordID,this.gallery_type);
    },
    //设置当前页
    async imghandleCurrentChange(val) {
      this.imgpage = val;
      await this.getapplypublicitygalleryinfolist(this.imgpage, this.imgpageSize, this.imgapplyRecordID,this.gallery_type);
    },
    async getapplypublicitygalleryinfolist(page,pagesize,apply_record_id,gallery_type) {
      this.showDataLoadingimg = true;
      await applypublicitygalleryinfolistModel.applypublicitygalleryinfolist( page,pagesize,apply_record_id,gallery_type)
        .then((response) => {
          this.showDataLoadingimg = false;
          switch (response.data.code) {
            case 100:
              this.gallerylist = response.data.result;
              this.imgtotalCount =  response.data.recordcount;
             
              break;
            case 101:
            this.gallerylist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
    .pageblock{
        text-align: right;
        margin-top: 5px;
    }
    .tablecolumn{
    margin-left: 10px;
    margin-top: 5px;
}

.addorganization .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.pm_p1{
    min-width: 100% !important;
    /* width: 100%; */
}

</style>